module.exports = __webpack_public_path__ + "static/media/sketch1.663747b9.jpg";